import * as types from './constants';

import { request, requestConfig } from 'utils/request';
import { PATHS } from 'utils/paths';

const getAggregateDataStart = () => ({
    type: types.GET_AGGREGATE_DATA_START
});

const getAggregateDataSuccess = (data) => ({
    type: types.GET_AGGREGATE_DATA_SUCCESS,
    data
});

const getAggregateDataFailure = (error) => ({
    type: types.GET_AGGREGATE_DATA_FAILURE,
    error
});


const sendAggregateDataStart = () => ({
    type: types.SEND_AGGREGATE_DATA_START
});

const sendAggregateDataSuccess = (data) => ({
    type: types.SEND_AGGREGATE_DATA_SUCCESS,
    data
});

const sendAggregateDataFailure = (error) => ({
    type: types.SEND_AGGREGATE_DATA_FAILURE,
    error
});


/**
 *  ASYNC ACTIONS
 */
export const getAggregateData = () => (dispatch, getStore) => {
    dispatch(getAggregateDataStart());

    return request(PATHS.aggregateData.get(), requestConfig('GET', null, getStore().auth.token))
        .then((response) => {
            console.log('aggregate data response', response.data);
            let regions = {};
            Object.keys(response.data.regions).forEach((key) => {
                if(key !== 'global') {
                    let average = response.data.regions[key].find((d) => d.isRollup);
                    let data = response.data.regions[key].filter((d) => !d.isRollup);
                    regions[key] = {
                        average,
                        data
                    };
                }
            });
            let globalData = {
                average: response.data.regions.global.find((d) => d.isRollup),
                data: response.data.regions.global.filter((d) => !d.isRollup)
            };
            dispatch(getAggregateDataSuccess({globalData, regionalData: regions, computedAt: response.data.computedAt}));
            return response;
        })
        .catch((error) => {
            console.log('error getting aggregate data', error);
            error.friendlyMessage = 'There was an error getting aggregate data. Please try again.';
            dispatch(getAggregateDataFailure(error));
            return error;
        });
};


export const sendAggregateData = () => (dispatch, getStore) => {
    dispatch(sendAggregateDataStart());

    return request(PATHS.aggregateData.send(), requestConfig('POST', null, getStore().auth.token))
        .then((response) => {
            dispatch(sendAggregateDataSuccess());
            return response;
        })
        .catch((error) => {
            console.log('error', error);
            error.friendlyMessage = 'There was an error sending a CSV of the aggregate data to your email. Please try again.';
            dispatch(sendAggregateDataFailure(error));
            throw error;
        });
};



// WEBPACK FOOTER //
// ./src/containers/AggregateData/store/actions.js